// extracted by mini-css-extract-plugin
export default {"unknownError":"error_unknownError__2W0Pa"};